import React from "react";
import { Col, ControlLabel, Row } from "react-bootstrap";

import {
  CardNumberField,
  CardExpiryField,
  CardCVCField,
} from "../../Shared/FormHelpers";
import { Image, ConfirmButton, PaymentTitle, TextField, CustomFormGroup } from "./index.style";
import { Label } from "../../Styles";
import Loader from "../../Shared/Loader";

const PaymentForm = ({
  handleSubmit,
  handleAdress2,
  handleAdress1,
  handleCardOwner,
  address1,
  address2,
  cardOwner,
  loading
}) => (
  <div>
    <PaymentTitle>Payment Details </PaymentTitle>
    <Image md={6}> </Image>
    <form onSubmit={handleSubmit}>
      <Col md={6}>
        <Label componentClass={ControlLabel} sm={2}>
          Card Number
        </Label>
        <CardNumberField title="Card Number" required />
        <Row>
          <Col md={6}>
            <Label componentClass={ControlLabel} sm={2}>
              Expiration Date
            </Label>
            <CardExpiryField placeholder="M M  /  Y Y" required />
          </Col>
          <Col md={6}>
            <Label componentClass={ControlLabel} sm={2}>
              CVC
            </Label>
            <CardCVCField title="CVC" required />
          </Col>
        </Row>

        <CustomFormGroup>
          <Label> Address 1 </Label>
          <TextField
            onChange={handleAdress1}
            value={address1}
            placeholder="59 West 46th Str, New York City, NY 10036"
            required
          />
        </CustomFormGroup>

        <CustomFormGroup>
          <Label> Address 2 <small> [optional] </small> </Label>
          <TextField
            onChange={handleAdress2}
            value={address2}
            placeholder="59 West 46th Str, New York City, NY 10036"
          />
        </CustomFormGroup>

        <CustomFormGroup>
          <Label> Card Holder's Name </Label>
          <TextField
            onChange={handleCardOwner}
            value={cardOwner}
            placeholder="john doe"
            required
          />
        </CustomFormGroup>
      </Col>
      <ConfirmButton type="submit" disabled={loading}>
          {loading ? (
            <Loader width={25} height={25} show={true} />
          ) : (
            "Confirm"
          )}
      </ConfirmButton>
    </form>
  </div>
);

export default PaymentForm;
